import Enumeration from '@enums/enum';

export const RankingPreferencesEnum = new Enumeration({
  COMPARISON_RATE: 'interest_rate',
  INTEREST_RATE: 'comparison_rate',
});

export function getRankingPreferences() {
  return [
    RankingPreferencesEnum.COMPARISON_RATE,
    RankingPreferencesEnum.INTEREST_RATE,
  ];
}
